/**
 * Search-criteria label resolution (Row 8 of the 22-janv-26 design).
 *
 * Labels shown for the "Résumé des critères de recherche" panel differ
 * depending on whether the user came from Recherche rapide or Recherche multichoix:
 *
 *   Rapide     : Culture | Pratique culturale | Type de traitement | Type d'application
 *                + (herbicides only) Période d'intervention sur la culture
 *   Multichoix : Cultures | Pratique culturale | Type de traitement | Ennemis
 *                | Périodes d'intervention sur les cultures | Type d'application
 *
 * Used by both the results-page panel (InitialCriteriaPanel) and the
 * treatment-detail recap (TreatmentCriteriaSummary).
 */

const FIELD_LABEL_KEYS = {
  rapide: {
    'treatment_cultures.culture': 'treatment-search|criteriaSummary.rapide.cultures',
    culture: 'treatment-search|criteriaSummary.rapide.cultures',
    cultures: 'treatment-search|criteriaSummary.rapide.cultures',
    'treatment_cultures.cultural_practices':
      'treatment-search|criteriaSummary.rapide.cultural_practices',
    cultural_practices: 'treatment-search|criteriaSummary.rapide.cultural_practices',
    treatment_type: 'treatment-search|criteriaSummary.rapide.treatment_types',
    treatment_types: 'treatment-search|criteriaSummary.rapide.treatment_types',
    application_type: 'treatment-search|criteriaSummary.rapide.application_types',
    application_types: 'treatment-search|criteriaSummary.rapide.application_types',
    intervention_period: 'treatment-search|criteriaSummary.rapide.intervention_periods',
    intervention_periods: 'treatment-search|criteriaSummary.rapide.intervention_periods',
  },
  multichoix: {
    'treatment_cultures.culture': 'treatment-search|criteriaSummary.multichoix.cultures',
    culture: 'treatment-search|criteriaSummary.multichoix.cultures',
    cultures: 'treatment-search|criteriaSummary.multichoix.cultures',
    'treatment_cultures.cultural_practices':
      'treatment-search|criteriaSummary.multichoix.cultural_practices',
    cultural_practices: 'treatment-search|criteriaSummary.multichoix.cultural_practices',
    treatment_type: 'treatment-search|criteriaSummary.multichoix.treatment_types',
    treatment_types: 'treatment-search|criteriaSummary.multichoix.treatment_types',
    'treatment_enemies.enemy': 'treatment-search|criteriaSummary.multichoix.enemies',
    enemy: 'treatment-search|criteriaSummary.multichoix.enemies',
    enemies: 'treatment-search|criteriaSummary.multichoix.enemies',
    intervention_period: 'treatment-search|criteriaSummary.multichoix.intervention_periods',
    intervention_periods: 'treatment-search|criteriaSummary.multichoix.intervention_periods',
    application_type: 'treatment-search|criteriaSummary.multichoix.application_types',
    application_types: 'treatment-search|criteriaSummary.multichoix.application_types',
  },
};

/** Fields dropped from the rapide recap (enemies are multichoix-only). */
const RAPIDE_EXCLUDED_FIELDS = [
  'treatment_enemies.enemy',
  'enemy',
  'enemies',
];

/**
 * Normalise an arbitrary search-mode string down to 'rapide' or 'multichoix'.
 * `extraction` reuses the multichoix form so its labels follow multichoix rules.
 */
export function normalizeSearchMode(searchMode) {
  if (searchMode === 'multichoix' || searchMode === 'extraction') return 'multichoix';
  return 'rapide';
}

/** Returns the i18n translation key for a field given the search mode. */
export function getCriteriaLabelKey(field, searchMode) {
  const mode = normalizeSearchMode(searchMode);
  return FIELD_LABEL_KEYS[mode][field] || null;
}

/** True if the field must be hidden for the given search mode. */
export function shouldHideCriteriaField(field, searchMode) {
  const mode = normalizeSearchMode(searchMode);
  return mode === 'rapide' && RAPIDE_EXCLUDED_FIELDS.includes(field);
}
